module.exports = __webpack_public_path__ + "static/img/v40.0280be9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v40.png
// module id = KY+A
// module chunks = 1